export default __webpack_public_path__ + "static/Infrastruture-e957f6f56036f6d75098ffbfe3495d51.png";